import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import HomeRegistration from '../components/home/Registration'
import HomeResult from '../components/home/Result'
import HomeStart from '../components/home/Start'

const ApplicationRouter = () => (
  <Router>
    <div className="body-wrapper">
      <Route exact path="/" component={HomeStart} />
      <Route exact path="/registration" component={HomeRegistration} />
      <Route exact path="/result" component={HomeResult} />
    </div>
  </Router>
)

export default ApplicationRouter



// WEBPACK FOOTER //
// ./src/routes/ApplicationRouter.js